import {  Formik } from "formik";
import { GetWfsResponseTimeRequest } from "../../../types/WfsLog/GetWfsResponseTimeRequest";
import { User } from "../../../types/User";
import { timeSchema } from "../RequestHistory/timeSchema";
import { DateTime } from "luxon";
import { Col, Row, Form, FormSelect, Button } from "react-bootstrap";
import UserSearch from "../../userSearch/UserSearch";
import GetWfsResponseTimeRequestService from "../../../services/GetWfsResponseTimeRequestService";
import LayerDropdown from "../../layerDropdown/LayerDropdown";
import styled from "styled-components";
import TimeInput from "../../../form/time/timeInput";
import { ResponseTimeGranularity } from "../../../constant/ResponseTimeGranularity";
import { useMemo } from "react";


interface  RequestStatisticFiltersProps {
    filterRequest: GetWfsResponseTimeRequest;
    setFilterRequest: (request: GetWfsResponseTimeRequest) => void;
    setSelectedUser: (user: User | undefined) => void;
    selectedUser?: User;
    getWfsResponseTimeRequestService: GetWfsResponseTimeRequestService;
    setGranularity: (granularity: ResponseTimeGranularity) => void;
    onChange: (e: React.ChangeEvent<any>) => void;
}

interface TimeForm {
    startDate: string;
    startTime:string;
    endDate:string;
    endTime:string;
  }
  const TimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const SubmitCol = styled(Col)`
  display: flex;
  justify-content: flex-start;
  align-items: end;
`;

const RequestStatisticFilters = ({
    filterRequest, 
    setFilterRequest, 
    setSelectedUser, 
    selectedUser, 
    getWfsResponseTimeRequestService, 
    setGranularity, 
    onChange
}:RequestStatisticFiltersProps) => {
    const timeValues = useMemo(() => ({
        startDate: filterRequest.startDate?.toISO()?.split("T")[0] || '',
        startTime: filterRequest.startDate?.toISO()?.split("T")[1]?.split("+")[0].slice(0, 8) || '',
        endDate: filterRequest.endDate?.toISO()?.split("T")[0] || '',
        endTime: filterRequest.endDate?.toISO()?.split("T")[1]?.split("+")[0].slice(0, 8) || '',
    }), [filterRequest]) as TimeForm;
    
    const timeSubmit = (timeValues: TimeForm) => {
        setFilterRequest({
          ...filterRequest,
          startDate: DateTime.fromISO(`${timeValues.startDate}T${timeValues.startTime}`),
          endDate: DateTime.fromISO(`${timeValues.endDate}T${timeValues.endTime}`),
        });
      };
      
    
    return <Formik
    validationSchema={timeSchema}
    onSubmit={timeSubmit}
    enableReinitialize={true}
    initialValues={timeValues}
  >
      {({ values, handleSubmit, handleChange, setFieldValue, errors }) => (
        <Form  onSubmit={handleSubmit}>
    <Row>
      <Col md="4">
        <Form.Group>
          <Form.Label>Search users</Form.Label>
          <UserSearch
              onUserClear={() => {
                setFilterRequest({ ...filterRequest, userId: undefined });
                setSelectedUser(undefined);
              }}
              onUserSelect={(user: User) => {
                setFilterRequest({ ...filterRequest, userId: user.id });
                setSelectedUser(user);
              }
              }
              selectedUser={selectedUser}
            />
        </Form.Group>
      </Col>
      <Col md="4">
        <Form.Group>
          <Form.Label>Granularity</Form.Label>
          <FormSelect
            value={filterRequest.granularity}
            onChange={(e: React.ChangeEvent<any>) =>
              setGranularity(e.target.value)
            }
            name="granularity"
          >
            {getWfsResponseTimeRequestService.granularityOptions.map((x) => (
              <option key={x.value} value={x.value}>
                {x.label}
              </option>
            ))}
          </FormSelect>
        </Form.Group>
      </Col>
      <Col md="4">
        <Form.Group>
          <Form.Label>Layer:</Form.Label>
          <LayerDropdown onChange={onChange} value={filterRequest.layer} />
        </Form.Group>
      </Col>
    </Row>
    <Row className="mt-1">
      <Col md="4">
      <Form.Group>
          <Form.Label>Logs after:</Form.Label>
          <TimeContainer>
            <Form.Control
              className="w-50"
              type="date"
              value={values.startDate}
              onChange={handleChange}
              name="startDate"
            />
          <TimeInput 
            className="w-50" 
            value={values.startTime} 
            onChange={(value:string) => setFieldValue("startTime", value)}
            name="startTime"
            hasError={!!errors.startTime}
          />
        </TimeContainer>
        </Form.Group>
      </Col>
      <Col md="4">
      <Form.Group>
          <Form.Label>Logs before:</Form.Label>
          <TimeContainer>
            <Form.Control
              className="w-50"
              type="date"
              value={values.endDate}
              onChange={handleChange}
              name="endDate"
            />
          <TimeInput 
            className="w-50" 
            value={values.endTime}
            onChange={(value:string) => setFieldValue("endTime", value)}
            name="endTime"
            hasError={!!errors.startTime}
          />
        </TimeContainer>
        </Form.Group>
      </Col>
      <SubmitCol md="4">
            <Button type="submit">Apply Range</Button>
      </SubmitCol>
    </Row>
    </Form>
)}
</Formik>;
};

export default RequestStatisticFilters;